import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const checkIcon: SvgIconData = {
  viewBox: '1 1 22 22',
  element: (
    <path d="M12 23A11 11 0 1 0 1 12a11 11 0 0 0 11 11ZM6.3 12.3a1 1 0 0 1 1.4 0l2.3 2.3 5.8-5.8a1 1 0 0 1 1.4 1.4l-6.5 6.5a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 0-1.4Z" />
  ),
};
